<template>
  <div class="flex-wrapper">
    <notifications position="bottom left" />

    <LoginDialog />
    <LoadingDialog />
    <MessageDialog />

    <VDNavbar />
    <slot />
    <!-- <Footer /> -->
  </div>
</template>

<script>
/**
 * Represents the base template for a given view.
 * Sets itself as the base component used in App.vue 'getBaseComponent'.
 * Use this template for Frontend (i.e. views that don't require login) views.
 * NOTE: This view structucture can be replicated however many times to create different base templates (see DashboardBaseTemplate.vue).
 *
 * Includes the Alert component to set alerts at the desired spot.
 *
 * Includes BaseDialogMixin that adds the dialog functions to this view and children (inherited) views.
 * Includes BaseAlertMixin that adds the alert functions to this view and children (inherited) views.
 */

import VDNavbar from "@/components/frontend/VDNavbar.vue";
// import Footer from "@/components/frontend/Footer.vue";

import BaseDialogMixin from "@/components/mixins/BaseDialogMixin.vue";
import BaseAlertMixin from "@/components/mixins/BaseAlertMixin.vue";

import LoginDialog from "@/components/dialogs/LoginDialog.vue";
import MessageDialog from "@/components/dialogs/MessageDialog.vue";
import LoadingDialog from "@/components/dialogs/LoadingDialog.vue";

import store from "@/store/store";

import { mapActions } from "vuex";

export default {
  mixins: [BaseDialogMixin, BaseAlertMixin],
  components: {
    VDNavbar,
    // Footer,
    LoginDialog,
    MessageDialog,
    LoadingDialog
  },
  beforeRouteEnter(to, from, next) {
    // this.setBaseComponent('BaseTemplate.vue');
    store.dispatch("setBaseComponent", "VDBaseTemplate");
    next();
  },
  beforeRouteUpdate(to, from, next) {
    this.setBaseComponent("VDBaseTemplate");
    next();
  },
  created: function() {
    this.setBaseComponent("VDBaseTemplate");
    this.setUserOnMobile();
  },
  data(){
        return{
            userOnMobile: false,
        };
    },
  computed: {},
  methods: {
    ...mapActions(["setBaseComponent"]),
    setUserOnMobile () {
      const that = this;

      function detectMob() {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];

        that.userOnMobile = toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
      }

      return detectMob();
    },
  },
};
</script>

<style scoped>
:root {
    --vt_lightcol: #fffba7;
    --vt_darkcol: #FFE47A;
    --vt_vdarkcol: #dcc26d;
    --vt_offwhite: #DFF2D8;
    --vt_grey: #B4B8AB;
    --vt_offblack: #153243;

    --vd_lightcol: #b0e7ff;
    --vd_darkcol: #96c6dc;
    --vd_offwhite: #DFF2D8;
    --vd_grey: #605C4E;
    --vd_offblack: #363020;
}

h1 {
    color: var(--vd_offblack);
}

h2 {
    color: var(--vd_offblack);
}

p.outset {
    border-style: groove;
    color: black;
}

p {

    font-size: large;
    color: var(--vd_offblack);
}

hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1em 0;
    padding: 0;
}

a {
    color: royalblue;
}

a:hover {
    color: cornflowerblue;
    text-decoration: none;
}

/* Container holding the image and the text */
.container {
    position: relative;
    text-align: center;
    color: white;
}

/* Bottom left text */
.bottom-left {
    position: absolute;
    bottom: 8px;
    left: 16px;
}

/* Top left text */
.top-left {
    position: absolute;
    top: 8px;
    /* top: 70px; */
    left: 16px;
}

.navbar-light-background {
    background: linear-gradient(70deg, #96c6dc,  #b0e7ff) !important;
}

</style>